{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "loading": "Loading...",
    "back": "Back",
    "next": "Next",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "close": "Close",
    "open": "Open",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "language": "Language",
    "settings": "Settings",
    "logout": "Log out",
    "today": "Today",
    "yesterday": "Yesterday",
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "from": "From",
    "to": "To",
    "load": "Load",
    "ascending": "Ascending",
    "descending": "Descending",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "saved": "Saved",
    "error": "Error",
    "noData": "No data"
  },
  "sidebar": {
    "restaurantManagement": "Restaurant Management",
    "dashboard": "Overview",
    "newOrder": "New Order",
    "preorders": "Pre-orders",
    "kitchen": "Kitchen",
    "dispatch": "Dispatch - board",
    "restaurant": "Restaurant",
    "tableMap": "Table Map",
    "kitchenManagement": "Kitchen Management",
    "categories": "Categories",
    "products": "Products",
    "lunchMenu": "Lunch Menu",
    "kombo": "Combo BOX",
    "pizza": "Pizza",
    "stockManagement": "Stock Management",
    "stock": "Stock Management",
    "recipes": "Recipes",
    "beverageStock": "Beverage Stock",
    "analytics": "Analytics",
    "statistics": "Statistics",
    "summaries": "Summaries",
    "companyManagement": "Company Management",
    "companyOverview": "Company Overview",
    "suppliers": "Suppliers",
    "supplierComparison": "Price Comparison",
    "invoices": "Invoices",
    "outgoingInvoices": "Issued Invoices",
    "recurringInvoices": "Recurring Invoices",
    "reorderDrafts": "Reorder Drafts",
    "banking": "Bank - auto-payments",
    "listsAndArchive": "Lists & Archive",
    "fiskalReceipts": "Fiscal Receipts",
    "onlinePayments": "Online Payments - archive",
    "deliveryManagement": "Delivery Management",
    "deliveryStats": "Delivery",
    "externalDriver": "External Driver",
    "vehicleFleet": "Vehicle Fleet",
    "tripLog": "Trip Log",
    "deliverySettings": "Delivery Settings",
    "marketing": "Marketing",
    "loyaltyProgram": "Loyalty Program",
    "gifts": "Order Gifts",
    "coupons": "Coupons & Discounts",
    "employees": "Employees",
    "permissions": "Role Permissions",
    "attendance": "Attendance",
    "revenueHandovers": "Revenue Handovers",
    "systemSettings": "System Settings",
    "designSettings": "Page Design",
    "openingHours": "Opening Hours",
    "deliveryZones": "Delivery Zones",
    "fiskal": "POS - settings",
    "fiskalClosures": "POS - closures",
    "qrPayment": "QR Payment (SEPA)",
    "mobileApp": "Mobile App",
    "cms": "CMS Pages",
    "general": "General Settings",
    "integrations": "Wolt / Bolt Integration",
    "smsSettings": "SMS Settings",
    "emailSettings": "Email Settings",
    "monitoring": "Monitoring & Alerts",
    "backups": "Database Backups",
    "hikvision": "Hikvision Devices",
    "logs": "Logs",
    "franchises": "Branches (Super Admin)",
    "franchiseAdmins": "Branch Admins (Super Admin)"
  },
  "profile": {
    "title": "My Profile",
    "subtitle": "Personal data, security and attendance - all in one place",
    "tabs": {
      "personal": "Personal Data",
      "security": "Security",
      "performance": "My Performance",
      "attendance": "My Attendance"
    },
    "firstName": "First Name",
    "lastName": "Last Name",
    "bio": "About Me",
    "preferredLanguage": "Interface Language",
    "uploadAvatar": "Change profile photo",
    "removeAvatar": "Remove photo",
    "save": "Save changes",
    "unsavedChanges": "Unsaved changes",
    "memberSince": "Team member since {{date}}",
    "emailVerified": "Email verified",
    "emailNotVerified": "Email unverified",
    "external": "External",
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password (min. 6 chars)",
    "confirmPassword": "Confirm new password",
    "logoutAll": "Log out everywhere",
    "lastActivity": "Recent activity",
    "securityTips": "Security tips"
  },
  "header": {
    "myProfile": "My profile",
    "myAttendance": "My attendance",
    "security": "Security",
    "logout": "Log out",
    "uzavierka": "Closure",
    "notifications": "Notifications"
  },
  "attendance": {
    "title": "My attendance",
    "arrive": "Clock in",
    "leave": "Clock out",
    "notInShift": "Off shift",
    "inShift": "On shift",
    "shiftClosed": "Shift closed",
    "haveANiceDay": "Have a nice rest of the day",
    "editTimes": "Edit shift times",
    "totalWorked": "Worked",
    "workingDays": "Working days",
    "completedShifts": "Completed shifts",
    "averagePerShift": "Average / shift"
  },
  "ai": {
    "title": "AI translation (Claude)",
    "description": "Automatically translate product names, descriptions and content via Claude API.",
    "apiKey": "Claude API key",
    "apiKeyPlaceholder": "sk-ant-...",
    "apiKeyHelp": "Get one at console.anthropic.com",
    "enableAuto": "Auto-translate on product create/update",
    "enabledLanguages": "Enabled languages",
    "enabledLanguagesHelp": "Pick the languages for your location (neighbours)",
    "test": "Test",
    "testSuccess": "API key works - translation succeeded",
    "testFail": "Test failed",
    "missingKey": "API key not set"
  }
}
